module.exports = "/static/assets/93241021a13aa20da27f50e661016310.png";